module.exports = __webpack_public_path__ + "img/table4.4b97741f.png";